/* Frequently Bought Together (sections/kkumi-product-fbt.liquid).
 *
 * State is the set of rows carrying .is-on — the base product (.is-base) is
 * always on. Sold-out add-ons (data-available="0") are never pickable; a
 * sold-out base variant disables the CTA, because Shopify rejects the whole
 * multi-item add when any line is out of stock. Every visible string comes
 * from the section's data-* attributes (theme-editor settings); the literals
 * below are fallbacks only. Prices are
 * integer cents throughout so the discount maths never drifts. */
(function () {
  var el = window.KKEl;

  function fill(tpl, map) {
    return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? String(map[k]) : m;
    });
  }

  function setText(node, text) {
    if (node && node.textContent !== text) node.textContent = text;
  }

  function init(root) {
    if (root.dataset.kkBound === '1') return;
    root.dataset.kkBound = '1';

    var d = root.dataset;
    var threshold = parseInt(d.bundleThreshold || '3', 10);
    var pct = parseFloat(d.bundlePercent || '0');
    var afterAdd = d.afterAdd || 'redirect';
    var copy = {
      meterMore: d.meterMore || 'Add [count] more to save [percent]%',
      meterUnlocked: d.meterUnlocked || '✦ [percent]% off unlocked',
      addAll: d.addAll || 'Add all [count]',
      addOther: d.addOther || 'Add the other [count]',
      addSave: d.addSave || 'Save [amount] total',
      countOne: d.countOne || '[count] item',
      countMany: d.countMany || '[count] items',
      totalLabel: d.totalLabel || 'Total · [items]',
      ctaSingle: d.ctaTemplateSingle || 'Add to cart',
      ctaPair: d.ctaTemplatePair || 'Add 2 to cart',
      ctaMany: d.ctaTemplateMany || 'Add [count] to cart',
      ctaBusy: d.ctaBusyLabel || 'Adding to cart…',
      ctaAdded: d.ctaAddedLabel || 'Added to cart',
      ctaSoldOut: d.ctaSoldOutLabel || 'Sold out',
      ctaBackorder: d.backorderLabel || 'Backorder now',
      errSelect: d.statusErrSelect || 'Select at least one item.',
      errAdd: d.statusErrAdd || 'Could not add to cart.',
      errNetwork: d.statusErrNetwork || 'Network error. Please try again.'
    };

    function q(sel) { return root.querySelector(sel); }
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-kkfbt-item]'));
    // Rows the shopper can end up with: in-stock add-ons plus the base row.
    var pool = items.filter(function (it) { return it.classList.contains('is-base') || it.dataset.available !== '0'; });
    var currentItem = root.querySelector('[data-kkfbt-item][data-current="1"]');
    var added = false;
    var segs = Array.prototype.slice.call(root.querySelectorAll('.kkfbt__meter-seg'));
    var meterMsg = q('[data-kkfbt-meter-msg]');
    var meterN = q('[data-kkfbt-meter-n]');
    var allBtn = q('[data-kkfbt-all]');
    var allTxt = q('[data-kkfbt-all-txt]');
    var allSave = q('[data-kkfbt-all-save]');
    var thumbsEl = q('[data-kkfbt-thumbs]');
    var countEl = q('[data-kkfbt-count]');
    var subEl = q('[data-kkfbt-subtotal]');
    var saveLine = q('[data-kkfbt-save-line]');
    var saveEl = q('[data-kkfbt-save]');
    var totalLabelEl = q('[data-kkfbt-total-label]');
    var totalEl = q('[data-kkfbt-total]');
    var wasEl = q('[data-kkfbt-was]');
    var pointsEl = q('.kkumi-earn-points');
    var ctaEl = q('[data-kkfbt-cta]');
    var statusEl = q('[data-kkfbt-status]');

    function money(cents) { return window.KKMoney.fromCents(cents); }
    function cents(it) { return parseInt(it.dataset.priceCents || '0', 10) || 0; }
    function discounted(c) { return Math.round(c * (100 - pct) / 100); }
    function isOn(it) { return it.classList.contains('is-on'); }
    function countLabel(n) { return fill(n === 1 ? copy.countOne : copy.countMany, { count: n }); }

    // "Add [count] more to save [percent]%" with the count in <b>.
    function renderMeterMsg(need, unlocked) {
      if (!meterMsg) return;
      var key = unlocked ? 'ok' : 'more:' + need;
      if (meterMsg.dataset.state === key) return;
      meterMsg.dataset.state = key;
      if (unlocked) {
        meterMsg.replaceChildren(el('span', 'kkfbt__meter-ok', fill(copy.meterUnlocked, { percent: pct })));
        return;
      }
      var parts = fill(copy.meterMore, { percent: pct }).split('[count]');
      var nodes = [];
      parts.forEach(function (part, i) {
        if (i > 0) nodes.push(el('b', null, String(need)));
        if (part) nodes.push(document.createTextNode(part));
      });
      meterMsg.replaceChildren.apply(meterMsg, nodes);
    }

    function renderPrice(it, ok) {
      var c = cents(it);
      var on = ok && isOn(it);
      var key = (on ? 'd' : 'f') + c;
      Array.prototype.forEach.call(it.querySelectorAll('[data-kkfbt-price]'), function (p) {
        if (p.dataset.state === key) return;
        p.dataset.state = key;
        if (on) p.replaceChildren(el('s', null, money(c)), document.createTextNode(money(discounted(c))));
        else p.textContent = money(c);
      });
    }

    function renderThumbs(sel) {
      if (!thumbsEl) return;
      thumbsEl.replaceChildren.apply(thumbsEl, sel.map(function (it) {
        var t = el('span', 'kkfbt__thumb');
        if (it.dataset.thumb) {
          var img = el('img');
          img.src = it.dataset.thumb;
          img.alt = '';
          img.loading = 'lazy';
          t.appendChild(img);
        }
        return t;
      }));
    }

    function recalc() {
      var sel = items.filter(isOn);
      var n = sel.length;
      var hasBackorder = sel.some(function (it) { return it.dataset.stockState === 'backorder'; });
      var backorderNotice = q('[data-kk-backorder-note]');
      if (backorderNotice) backorderNotice.hidden = !hasBackorder;
      var ok = pct > 0 && n >= threshold;
      var subtotal = sel.reduce(function (s, it) { return s + cents(it); }, 0);
      var discount = ok ? Math.round(subtotal * pct / 100) : 0;
      var total = subtotal - discount;

      // Meter
      segs.forEach(function (s, i) { s.classList.toggle('is-on', i < Math.min(n, threshold)); });
      setText(meterN, Math.min(n, threshold) + '/' + threshold);
      renderMeterMsg(Math.max(threshold - n, 0), n >= threshold);

      items.forEach(function (it) { renderPrice(it, ok); });

      // "Add all" shortcut
      if (allBtn) {
        var rest = pool.length - n;
        allBtn.hidden = rest === 0;
        setText(allTxt, n <= 1 ? fill(copy.addAll, { count: pool.length }) : fill(copy.addOther, { count: rest }));
        if (allSave) {
          var full = pool.reduce(function (s, it) { return s + cents(it); }, 0);
          allSave.hidden = pool.length < threshold;
          setText(allSave, fill(copy.addSave, { amount: money(Math.round(full * pct / 100)) }));
        }
      }

      // Summary
      renderThumbs(sel);
      setText(countEl, countLabel(n));
      setText(subEl, money(subtotal));
      if (saveLine) saveLine.hidden = !ok;
      setText(saveEl, '−' + money(discount));
      setText(totalLabelEl, fill(copy.totalLabel, { items: countLabel(n) }));
      setText(totalEl, money(total));
      if (wasEl) {
        wasEl.hidden = !ok;
        setText(wasEl, money(subtotal));
      }

      if (pointsEl) {
        pointsEl.dataset.initialTotalCents = String(total);
        if (window.KkumiEarnPoints) window.KkumiEarnPoints.setTotal(pointsEl, total);
      }

      // Base variant sold out → nothing can be added until the shopper picks
      // an in-stock one (the variant sync below flips data-available).
      var baseSoldOut = !!currentItem && currentItem.dataset.available === '0';
      if (currentItem) {
        currentItem.classList.toggle('is-sold-out', baseSoldOut);
        var soldTag = currentItem.querySelector('[data-kkfbt-sold-tag]');
        if (soldTag) soldTag.hidden = !baseSoldOut;
        var backorderTag = currentItem.querySelector('[data-kkfbt-backorder-tag]');
        if (backorderTag) backorderTag.hidden = currentItem.dataset.stockState !== 'backorder';
      }
      if (ctaEl && !added && ctaEl.getAttribute('aria-busy') !== 'true') ctaEl.disabled = baseSoldOut;

      // Re-query: KKBtn.reset() rebuilds the button and detaches old nodes.
      var ctaLabel = root.querySelector('[data-kkfbt-cta-label]');
      setText(ctaLabel, baseSoldOut ? copy.ctaSoldOut
        : n === 1 && hasBackorder ? copy.ctaBackorder : n === 1 ? copy.ctaSingle : n === 2 ? copy.ctaPair : fill(copy.ctaMany, { count: n }));
    }

    function setOn(it, on) {
      if (it.classList.contains('is-base') || pool.indexOf(it) === -1) return;
      it.classList.toggle('is-on', on);
      it.setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    pool.forEach(function (it) {
      if (it.classList.contains('is-base')) return;
      it.addEventListener('click', function () {
        setOn(it, !isOn(it));
        recalc();
      });
    });

    if (allBtn) {
      allBtn.addEventListener('click', function () {
        pool.forEach(function (it) { setOn(it, true); });
        recalc();
      });
    }

    // The "this item" row must add the variant the shopper picked above, not
    // the one the page happened to load with — otherwise changing tweezers or
    // bag colour and pressing the bundle CTA added a different variant at a
    // different price. Only a change on THIS product's main form counts. The row's
    // stock follows too, so a sold-out pick disables the CTA (and back).
    function mainFormVariantId(productId) {
      var infos = document.querySelectorAll('product-info[data-product-id="' + productId + '"]');
      for (var i = 0; i < infos.length; i++) {
        var input = infos[i].querySelector('product-form input[name="id"]');
        if (input) return input.value;
      }
      return null;
    }
    if (currentItem && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
        var v = payload && payload.data && payload.data.variant;
        if (!v || !v.id) return;
        setTimeout(function () {
          if (String(mainFormVariantId(currentItem.dataset.productId)) !== String(v.id)) return;
          currentItem.dataset.variantId = String(v.id);
          if (typeof v.price === 'number') currentItem.dataset.priceCents = String(v.price);
          var incoming = payload.data.html && payload.data.html.querySelector('product-info[data-kk-variants]');
          var states = [];
          try { states = JSON.parse(incoming && incoming.dataset.kkVariants || '[]'); } catch (_) {}
          var selected = states.find(function (state) { return String(state.id) === String(v.id); });
          var savedStates = {};
          try { savedStates = JSON.parse(currentItem.dataset.stockStates || '{}'); } catch (_) {}
          var state = selected ? selected.stockState : savedStates[String(v.id)];
          currentItem.dataset.stockState = state || 'unavailable';
          currentItem.dataset.available = state === 'in_stock' || state === 'backorder' ? '1' : '0';
          recalc();
        }, 0);
      });
    }

    function setStatus(msg) {
      if (!statusEl) return;
      statusEl.hidden = !msg;
      setText(statusEl, msg || '');
    }

    // Final, post-success state: spinner gone, button stays disabled with a
    // tick + "Added" — the bundle is in the cart, so the CTA is inert until
    // the page navigates. The tick markup is a trusted static constant.
    function markAdded(btn) {
      added = true;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'false');
      var tick = el('span', 'kkfbt__cta-tick');
      tick.setAttribute('aria-hidden', 'true');
      tick.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
      btn.replaceChildren(tick, document.createTextNode(copy.ctaAdded));
    }

    function resetCta() {
      if (window.KKBtn) window.KKBtn.reset(ctaEl); else ctaEl.disabled = false;
      recalc();
    }

    if (ctaEl) {
      ctaEl.addEventListener('click', function () {
        var selection = items.filter(isOn);
        if (selection.some(function (it) { return it.dataset.available === '0'; })) {
          setStatus(copy.ctaSoldOut);
          return;
        }
        var payload = selection.filter(function (it) { return it.dataset.variantId; })
          .map(function (it) {
            var properties = { _kkumi_bundle: '1' };
            if (it.dataset.stockState === 'backorder') {
              properties._backorder = '1';
              properties[d.backorderProperty || 'Availability'] = d.backorderNote;
            }
            return { id: parseInt(it.dataset.variantId, 10), quantity: 1, properties: properties };
          });

        if (!payload.length) {
          setStatus(copy.errSelect);
          return;
        }

        setStatus('');
        if (window.KKBtn) window.KKBtn.busy(ctaEl, copy.ctaBusy);
        else ctaEl.disabled = true;

        fetch((d.cartAddUrl || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: payload })
        })
          .then(function (res) {
            return res.json().then(function (body) { return { ok: res.ok, body: body }; });
          })
          .then(function (result) {
            if (!result.ok) {
              resetCta();
              setStatus((result.body && result.body.description) || copy.errAdd);
              return;
            }
            markAdded(ctaEl);
            document.dispatchEvent(new CustomEvent('cart:added', { detail: { items: result.body && result.body.items } }));
            if (afterAdd === 'redirect') window.location.href = d.cartUrl || '/cart';
            else if (afterAdd === 'reload') window.location.reload();
          })
          .catch(function () {
            resetCta();
            setStatus(copy.errNetwork);
          });
      });
    }

    recalc();
  }

  function boot() { document.querySelectorAll('[data-kkfbt]').forEach(init); }
  boot();
  // Theme editor re-renders the section in place — bind the fresh markup.
  document.addEventListener('shopify:section:load', boot);
})();
